angular.module("ainapp")
    .service('RecurrenceService', ['$q', '$window', "$http", "app.config",
        function ($q, $window, $http, config) {


            this.extractDate = function (date) {
                var Month = date.getMonth() + 1;
                Month = Month.toString();
                if (Month.length == 1) {
                    Month = '0' + Month;
                }
                var Day = date.getDate();
                Day = Day.toString();
                if (Day.length == 1) {
                    Day = '0' + Day;
                }
                var Year = date.getFullYear();
                Year = Year.toString();
                var newDate = Day + "/" + Month + "/" + Year;
                return newDate;
            }


            this.SaveRecurrence = function (data) {

                if (data.VoucherName == "Sales Invoice") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesInvoiceCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SaleInvoiceDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesInvoiceCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesInvoice", data.VoucherData);
                }
                if (data.VoucherName == "Sales Invoice 2") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesInvoice2Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SaleInvoice2Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesInvoice2Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesInvoice2", data.VoucherData);
                }
                if (data.VoucherName == "Sales Invoice 3") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesInvoice3Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SaleInvoice3Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesInvoice3Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesInvoice3", data.VoucherData);
                }
                if (data.VoucherName == "Sales Invoice 4") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesInvoice4Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SaleInvoice4Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesInvoice4Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesInvoice4", data.VoucherData);
                }

                if (data.VoucherName == "Sales Order") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesOrderCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesOrderDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesOrderCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesOrder", data.VoucherData);
                }
                if (data.VoucherName == "Sales Order 2") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesOrder2Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesOrder2Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesOrder2Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesOrder2", data.VoucherData);
                }
                if (data.VoucherName == "Sales Order 3") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesOrder3Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesOrder3Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesOrder3Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesOrder3", data.VoucherData);
                }
                if (data.VoucherName == "Sales Order 4") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesOrder4Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesOrder4Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesOrder4Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesOrder4", data.VoucherData);
                }

                if (data.VoucherName == "Sales Quotation") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesQuotationCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesQuotationDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesQuotationCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesQuotation", data.VoucherData);
                }
                if (data.VoucherName == "Sales Quotation 2") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesQuotation2Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesQuotation2Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesQuotation2Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesQuotation2", data.VoucherData);
                }
                if (data.VoucherName == "Sales Quotation 3") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesQuotation3Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesQuotation3Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesQuotation3Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesQuotation3", data.VoucherData);
                }
                if (data.VoucherName == "Sales Quotation 4") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesQuotation4Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesQuotation4Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesQuotation4Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesQuotation4", data.VoucherData);
                }

                if (data.VoucherName == "Sales Enquiry") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesEnquiryCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesEnquiryDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesEnquiryCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesEnquiry", data.VoucherData);
                }
                if (data.VoucherName == "Sales Enquiry 2") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesEnquiry2Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesEnquiry2Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesEnquiry2Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesEnquiry2", data.VoucherData);
                }
                if (data.VoucherName == "Sales Enquiry 3") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesEnquiry3Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesEnquiry3Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesEnquiry3Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesEnquiry3", data.VoucherData);
                }
                if (data.VoucherName == "Sales Enquiry 4") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesEnquiry4Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesEnquiry4Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesEnquiry4Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesEnquiry4", data.VoucherData);
                }

                if (data.VoucherName == "Delivery Note") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.DeliveryNoteCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.DeliveryNoteDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.DeliveryNoteCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddDeliveryNote", data.VoucherData);
                }
                if (data.VoucherName == "Delivery Note 2") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.DeliveryNote2Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.Delivery2NoteDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.DeliveryNote2Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddDeliveryNote2", data.VoucherData);
                }
                if (data.VoucherName == "Delivery Note 3") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.DeliveryNote3Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.DeliveryNote3Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.DeliveryNote3Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddDeliveryNote3", data.VoucherData);
                }
                if (data.VoucherName == "Delivery Note 4") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.DeliveryNote4Costs, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.DeliveryNote4Details, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.DeliveryNote4Costs, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddDeliveryNote4", data.VoucherData);
                }

                if (data.VoucherName == "Sales Return") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.SalesReturnCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.SalesReturnDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.SalesReturnCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddSalesReturn", data.VoucherData);
                }

                if (data.VoucherName == "Credit Note SR") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.CreditNoteSRCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.CreditNoteSRDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.CreditNoteSRCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddCreditNoteSR", data.VoucherData);
                }

                if (data.VoucherName == "Direct Sales Invoice") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.DirSalesInvoiceCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.DirSaleInvoiceDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.DirSalesInvoiceCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddDirSalesInvoice", data.VoucherData);
                }

                if (data.VoucherName == "Export Sales Invoice") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.ExpSalesInvoiceCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.ExpSaleInvoiceDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.ExpSalesInvoiceCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddExpSalesInvoice", data.VoucherData);
                }

                if (data.VoucherName == "Individual Sales Invoice") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.IndSalesInvoiceCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.IndSalesInvoiceDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.IndSalesInvoiceCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddIndSalesInvoice", data.VoucherData);
                }

                if (data.VoucherName == "Packing List") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.PackingListCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.PackingListDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.PackingListCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddPackingList", data.VoucherData);
                }

                if (data.VoucherName == "Porfoma Invoice") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.ProSalesInvoiceCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.ProSalesInvoiceDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.ProSalesInvoiceCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddPorSalesInvoice", data.VoucherData);
                }


                if (data.VoucherName == "Direct Purchase Invoice") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.DirPurchaseInvoiceCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.DirPurchaseInvoiceDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.DirPurchaseInvoiceCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddDirPurchaseInvoice", data.VoucherData);
                }
                if (data.VoucherName == "Export Purchase Invoice") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.ExpPurchaseInvoiceCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.ExpPurchaseInvoiceDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.ExpPurchaseInvoiceCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddExpPurchaseInvoice", data.VoucherData);
                }
                if (data.VoucherName == "Goods Received") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.GoodsReceivedCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.GoodsReceivedDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.GoodsReceivedCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddGoodsReceived", data.VoucherData);
                }
                if (data.VoucherName == "Import Purchase Invoice") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.ImpPurchaseInvoiceCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.ImpPurchaseInvoiceDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.ImpPurchaseInvoiceCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddImpPurchaseInvoice", data.VoucherData);
                }
                if (data.VoucherName == "Individual Purchase Invoice") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.IndPurchaseInvoiceCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.IndPurchaseInvoiceDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.IndPurchaseInvoiceCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddIndPurchaseInvoice", data.VoucherData);
                }
                if (data.VoucherName == "Purchase Enquiry") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.PurchaseEnquiryCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.PurchaseEnquiryDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.PurchaseEnquiryCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddPurchaseEnquiry", data.VoucherData);
                }
                if (data.VoucherName == "Purchase Invoice") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.PurchaseInvoiceCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.PurchaseInvoiceDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.PurchaseInvoiceCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddPurchaseInvoice", data.VoucherData);
                }
                if (data.VoucherName == "Purchase Order") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.PurchaseOrderCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.PurchaseOrderDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.PurchaseOrderCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddPurchaseOrder", data.VoucherData);
                }
                if (data.VoucherName == "Purchase Quotation") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.ProSalesInvoiceCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.ProSalesInvoiceDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.ProSalesInvoiceCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddPorSalesInvoice", data.VoucherData);
                }
                if (data.VoucherName == "Material Request") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.MaterialRequestCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.MaterialRequestDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.MaterialRequestCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddMaterialRequest", data.VoucherData);
                }

                if (data.VoucherName == "Purchase Request") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.PurchaseRequestCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.PurchaseRequestDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.PurchaseRequestCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddPurchaseRequest", data.VoucherData);
                }
                if (data.VoucherName == "Purchase Return") {

                    if (1 == 1) {
                        if (data.VoucherData.DeliveryDate != null) {
                            data.VoucherData.DelDateString = this.extractDate(data.VoucherData.DeliveryDate);
                        }
                        if (data.VoucherData.ReturnDate != null) {
                            data.VoucherData.RetDateString = this.extractDate(data.VoucherData.ReturnDate);
                        }
                        if (data.VoucherData.SupplierBillDate != null) {
                            data.VoucherData.SupDateString = this.extractDate(data.VoucherData.SupplierBillDate);
                        }
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.PurchaseReturnCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.PurchaseReturnDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.PurchaseReturnCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddPurchaseReturn", data.VoucherData);
                }
                if (data.VoucherName == "Stock Issue") {

                    if (1 == 1) {

                        data.VoucherData.DateMonth = data.VoucherData.Date.getMonth() + 1;
                        data.VoucherData.DateDay = data.VoucherData.Date.getDate();
                        data.VoucherData.DateYear = data.VoucherData.Date.getFullYear();

                        angular.forEach(data.VoucherData.StockIssueCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.StockIssuePayments, function (e) {
                            var date = e.Date;
                            var Month = date.getMonth() + 1;
                            Month = Month.toString();
                            if (Month.length == 1) {
                                Month = '0' + Month;
                            }
                            var Day = date.getDate();
                            Day = Day.toString();
                            if (Day.length == 1) {
                                Day = '0' + Day;
                            }
                            var Year = date.getFullYear();
                            Year = Year.toString();
                            e.DateString = Day + "/" + Month + "/" + Year;

                        });

                        angular.forEach(data.VoucherData.StockIssueDetails, function (e) {


                            angular.forEach(e.StockIssueCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "AddStockIssue", data.VoucherData);
                }

                  if (data.VoucherName == "Journal Voucher") {

                     if (1 == 1) {
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.JVMasterCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.JVDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.JVMasterCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "addJvMaster", data.VoucherData);
                }

                 if (data.VoucherName == "Company Expense") {

                     if (1 == 1) {
                        if (data.VoucherData.Field16 != null) {
                            data.VoucherData.F16DateString = this.extractDate(data.VoucherData.Field16);
                        }
                        if (data.VoucherData.Field17 != null) {
                            data.VoucherData.F17DateString = this.extractDate(data.VoucherData.Field17);
                        }
                        if (data.VoucherData.Field18 != null) {
                            data.VoucherData.F18DateString = this.extractDate(data.VoucherData.Field18);
                        }
                        if (data.VoucherData.Field19 != null) {
                            data.VoucherData.F19DateString = this.extractDate(data.VoucherData.Field19);
                        }
                        if (data.VoucherData.Field20 != null) {
                            data.VoucherData.F20DateString = this.extractDate(data.VoucherData.Field20);
                        }

                        angular.forEach(data.VoucherData.CompanyExpenseCosts, function (e) {
                            e.CostCenterId = e.CostCenter.Id;
                        });

                        angular.forEach(data.VoucherData.CompanyExpenseDetails, function (e) {

                            if (e.Field16 != null) {
                                e.F16DateString = this.extractDate(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.F17DateString = this.extractDate(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.F18DateString = this.extractDate(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.F19DateString = this.extractDate(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.F20DateString = this.extractDate(e.Field20);
                            }

                            angular.forEach(e.CompanyExpenseCosts, function (a) {
                                a.CostCenterId = a.CostCenter.Id;
                            });


                        });
                    }

                    return $http.post(config.basePath + "addCompanyexpense", data.VoucherData);
                }

                return null;
            };



    }]);
